import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

import { COLOR_RED } from '../colors';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getMuiRadio = (theme: Theme): ComponentsOverrides['MuiCheckbox'] => {
  const colorCommon = {
    color: theme.themeColors.colorRadioAndCheckboxBorder,
    '&.Mui-disabled': {
      color: theme.themeColors.colorRadioAndCheckboxBorder,
    },
    '&.Mui-checked': {
      color: theme.themeColors.colorRadioAndCheckboxChecked,
    },
  };
  const colorError = {
    color: theme.themeColors.colorRadioAndCheckboxBorder,
    '&.Mui-disabled': {
      color: theme.themeColors.colorRadioAndCheckboxBorder,
    },
    '&.Mui-checked': {
      color: COLOR_RED,
    },
  };
  return {
    root: {
      '& .MuiSvgIcon-root': {
        fontSize: 32,
      },
    },
    colorPrimary: colorCommon,
    colorSecondary: colorError,
  };
};

export const getMuiRadioDefaultProps = (): ComponentsProps['MuiCheckbox'] => ({
  color: 'primary',
});
